/**
 * @generated SignedSource<<1e2142d20412fb7ae4427ccb4af4f9bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TransactionType = "NEGOTIABLE" | "NON_NEGOTIABLE" | "OFF_PLATFORM" | "PRE_AUTH_NEGOTIATION" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPurchaseButton_item$data = {
  readonly hasPrivateListing: boolean | null;
  readonly isPrivateVisibilityType: boolean | null;
  readonly lastActiveTransaction: {
    readonly hasCompletedCheckout: boolean | null;
    readonly serviceId: string | null;
    readonly transactionType: TransactionType | null;
  } | null;
  readonly pdpTrackingVpvParams?: any | null;
  readonly " $fragmentSpreads": FragmentRefs<"actionButtonsTracking_item" | "usePrerenderedCheckout_item">;
  readonly " $fragmentType": "PdpSharedPurchaseButton_item";
};
export type PdpSharedPurchaseButton_item$key = {
  readonly " $data"?: PdpSharedPurchaseButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPurchaseButton_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "defaultValue": "pdp",
  "kind": "LocalArgument",
  "name": "pageDisplayEnum"
},
v1 = {
  "kind": "RootArgument",
  "name": "userId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "buyerId",
    "variableName": "userId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "USD",
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "pageDisplayEnum"
  }
],
v6 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ConvertedAmounts",
    "kind": "LinkedField",
    "name": "convertedAmounts",
    "plural": false,
    "selections": [
      (v4/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    (v0/*: any*/),
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    (v1/*: any*/),
    {
      "kind": "RootArgument",
      "name": "userZipCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPurchaseButton_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivateVisibilityType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "Transaction",
      "kind": "LinkedField",
      "name": "lastActiveTransaction",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasCompletedCheckout",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "transactionType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPrivateListing",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePrerenderedCheckout_item"
    },
    {
      "condition": "afterDisplay",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userCountryCode",
              "variableName": "userCountryCode"
            },
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            },
            {
              "kind": "Variable",
              "name": "userZipCode",
              "variableName": "userZipCode"
            }
          ],
          "kind": "ScalarField",
          "name": "pdpTrackingVpvParams",
          "storageKey": null
        }
      ]
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "actionButtonsTracking_item",
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contemporaryTrackingString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemPricing",
          "kind": "LinkedField",
          "name": "pricing",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "totalAmount",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ConvertedAmounts",
                  "kind": "LinkedField",
                  "name": "convertedAmounts",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "GBP",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "EUR",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "CAD",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "AUD",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "CHF",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "MXN",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "NOK",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "SEK",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "DKK",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAuctionEnabled",
          "storageKey": null
        },
        {
          "condition": "fetchAuction",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "alias": null,
              "args": (v5/*: any*/),
              "concreteType": "AuctionSolution",
              "kind": "LinkedField",
              "name": "relevantAuctionSolution",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AuctionBidsConnection",
                  "kind": "LinkedField",
                  "name": "bids",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalResults",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "highestBidAmount",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v5/*: any*/),
              "concreteType": "AuctionLot",
              "kind": "LinkedField",
              "name": "relevantAuctionLot",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "buyItNowPrice",
                  "plural": false,
                  "selections": (v6/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": (v2/*: any*/),
              "concreteType": "Transaction",
              "kind": "LinkedField",
              "name": "lastTransaction",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Offer",
                  "kind": "LinkedField",
                  "name": "secondChanceOffer",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "FinancialAmount",
                      "kind": "LinkedField",
                      "name": "amountPerItem",
                      "plural": false,
                      "selections": (v6/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ]
        }
      ],
      "args": [
        {
          "kind": "Literal",
          "name": "fetchAuction",
          "value": false
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        }
      ],
      "argumentDefinitions": [
        {
          "defaultValue": null,
          "kind": "LocalArgument",
          "name": "fetchAuction"
        },
        (v0/*: any*/),
        (v1/*: any*/)
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "74a78e6299037063bf74b48bf6f652b7";

export default node;
